import React from 'react'
import styles from './SubTitle.module.css'

const SubTitle = ({ children, ...rest }) => {
  return (
    <h2 className={styles.subTitle} {...rest}>
      {children}
    </h2>
  )
}

export default SubTitle
